<!-- 타겟그룹 설문응답 필터 -->
<template>
  <div>
    <div v-if="isSurveyAnswer">
      <!-- 설문 응답 설정 영역 -->
      <b-row class="mt-1">
        <b-col cols="12">
          <b-form-group>
            <label class="d-block">설문 응답</label>
            <b-button
              :disabled="isReadonly"
              variant="outline-primary"
              class="mt-0"
              @click.prevent="showTargetGroupFilters(filterType)"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              <span>설문 응답 추가</span>
            </b-button>
          </b-form-group>
          <b-table
            :items="targetGroupData.targetGroupFilters.filter(x => x.filterType === filterType)"
            :fields="selectedTableColumns"
            sort-by="filterId"
            :sort-desc="true"
            bordered
            empty-text="추가된 설문 응답이 없습니다."
          >
            <template #cell(isDelete)="data">
              <b-button
                variant="link"
                size="sm"
                class="btn-hover-trash"
                :disabled="isReadonly"
                @click.prevent="removeRow(data.item)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="16"
                  class="text-danger"
                />
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>

    <survey-answer-select
      v-if="filterType"
      :show-survey-answer-select="showSurveyAnswerSelect"
      :filter-type="filterType"
      :selected-value="targetGroupData.targetGroupFilters.filter(x => x.filterType === filterType).map(i=>i.filterId)"
      @close="surveyAnswerSelect.close"
    />

  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import SurveyAnswerSelect from '../../survey-manage/SurveyAnswerSelect.vue'

export default {
  components: {
    SurveyAnswerSelect,
  },
  props: {
    targetGroupData: {
      type: Object,
      required: true,
    },
    codes: {
      type: Object,
      required: true,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    filterType: {
      type: Number,
      required: false,
      default: null,
    },
    surveyAnswerToggleState: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const isSurveyAnswer = computed(() => props.surveyAnswerToggleState)

    const selectedTableColumns = [
      // {
      //   key: 'filterId', label: '', sortable: false, thStyle: { width: '8%' },
      // },
      {
        key: 'liveInfoId', label: 'ID', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'clientName', label: '제약사명', sortable: false, thStyle: { width: '10%' },
      },
      { key: 'title', label: '제목', sortable: false },
      { key: 'elementTitle', label: '문항', sortable: false },
      { key: 'answerDescription', label: '응답', sortable: false },
      {
        key: 'period', label: '게시 기간', sortable: false, thStyle: { width: '18%' },
      },
      {
        key: 'isDelete', label: '', sortable: false, thStyle: { width: '30px' }, tdClass: 'text-center p-0',
      },
    ]

    // 타겟 설문응답 지정
    const showSurveyAnswerSelect = ref(false)
    const surveyAnswerSelect = {
      close: rs => {
        showSurveyAnswerSelect.value = false
        if (!rs || rs.length === 0) return
        const existing = props.targetGroupData.targetGroupFilters.filter(x => x.filterType === props.filterType) || []

        // 신규 선택 설문응답만 추가
        const newFilters = []

        rs.forEach(item => {
          const alreadyExists = existing.some(x => x.filterId === item.filterId)
          if (!alreadyExists) {
            newFilters.push({
              ...item,
              filterType: props.filterType,
            })
          }
        })

        props.targetGroupData.targetGroupFilters.push(...newFilters)
      },
    }

    const showTargetGroupFilters = (ftType) => {
      if (ftType === props.filterType) {
        showSurveyAnswerSelect.value = true
      }
    }

    const removeRow = item => {
      const idx = props.targetGroupData.targetGroupFilters.findIndex(x => x.filterType === props.filterType && x.filterId === item.filterId)
      if (idx !== -1) {
        props.targetGroupData.targetGroupFilters.splice(idx, 1)
      }
    }

    return {
      isSurveyAnswer,
      selectedTableColumns,
      showSurveyAnswerSelect,
      surveyAnswerSelect,
      showTargetGroupFilters,
      removeRow,
    }
  },
}
</script>
<style scoped>
.btn-hover-trash:hover {
  background: linear-gradient(to right, #ffe5e5, #ffcccc);
  border-radius: 4px;
}
</style>
